import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { appActions } from './store';

import ChamUpload from './components/features/ChamUpload/ChamUpload';
import ChamProjects from './components/shared/ChamProjects/ChamProjects';
import VisualizerPage from './components/features/VisualizerPage/VisualizerPage';
import { getJsonBySeriesId } from './Helpers/JsonHelper';

function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        const seriesIds = [9727, 9728, 8623];

        seriesIds.forEach((seriesId) => {
            getJsonBySeriesId(seriesId).then((jsonData) => {
                const data = jsonData.reduce((acc, obj) => {
                    acc[obj.id] = obj;
                    return acc;
                }, {});

                dispatch(appActions.setSeriesData({ data, seriesId }));
            });
        });
    }, [dispatch]);

    return (
        <>
            <ChamProjects />
            <VisualizerPage />
            <ChamUpload />
        </>
    );
}

export default App;
